import { supabase } from "./supabase";

export async function saveLeadToFirestore({
  email,
  website,
  industry,
  recommended_tools,
}) {
  try {
    const { data, error } = await supabase
      .from("leads")
      .insert([
        {
          email,
          website,
          industry,
          recommended_tools,
          status: "new"
        },
      ]);

    if (error) throw error;

    return { success: true };
  } catch (error) {
    console.error(error);
    return { success: false };
  }
}

export async function fetchAllLeads() {
  try {
    const { data, error } = await supabase
      .from("leads")
      .select("*")
      .order("created_at", { ascending: false });

    if (error) throw error;

    return (data || []).map((row) => ({
      id: row.id,
      email: row.email,
      website: row.website,
      industry: row.industry,
      recommended_tools: row.recommended_tools || [],
      timestamp: row.created_at,
    }));
  } catch (error) {
    console.error("Error fetching leads:", error);
    return [];
  }
}
